import { pickBy } from "lodash-es";
import { environment } from "src/environments";
import { isExistent } from "src/utils";
import {
  AddDoorCollectionDTO,
  AddLocationDTO,
  AddMoveRequestCommentDTO,
  AddMoveRequestDTO,
  AddPartnerDTO,
  AddRFIDTrailerDTO,
  AddSiteDTO,
  AddTrailerMoveRequestDTO,
  AddTrailerTypeDTO,
  AddUserOrganizationInformationDTO,
  AddYardManagementInformationDTO,
  AppointmentDockDTO,
  AppointmentStatusesResponse,
  AppointmentWithYardManagementDTO,
  ChangeMoveRequestStatusCommand,
  CompleteMoveRequestCommand,
  DashboardDoorDTO,
  DashboardParentDTO,
  DisplayFieldsModel,
  DoorCollectionDTO,
  DoorCollectionWithDoorsDTO,
  DoorDTO,
  DropTrailersDTOPagedList,
  DropTrailersFiltersDTO,
  EnterprisePartnerDTO,
  EnterpriseSiteDTO,
  FilterByTrailerNumberAndScacDTO,
  FilterDashboardTrailersDTO,
  FilterDoorsByDoorCollectionDTO,
  FilterTrailersResponseDTO,
  GetDoorCollectionDTOPagedList,
  GetDoorCollectionFilterModel,
  GetLocationsListFilterModel,
  GetNewSignUpUsersFilterModel,
  GetPartnersFilterModel,
  GetRFIDTrailerSelectedListFilterModel,
  GetRFIDTrailersFilterModel,
  GetSCACDTOPagedList,
  GetSCACsFilterModel,
  GetSCACsSelectedListFilterModel,
  GetSelectedSCACDTOPagedList,
  GetSiteDTO,
  GetTrailerTypeDTOPagedList,
  GetTrailerTypesFilterModel,
  History,
  HistoryBase,
  LiveSpotMoveRequestDTO,
  LocationDetailsDTO,
  LocationDTO,
  LocationListDTO,
  LocationListDTOPagedList,
  LocationTypeDTO,
  MoveRequestCommentDTO,
  MoveRequestDTO,
  MoveRequestFilterModel,
  MoveRequestForListDTOPagedList,
  MRDoorDTO,
  MrSiteSettingsForYardManagementInformationDTO,
  NewSignUpUserModelPagedList,
  OffComplexTrailerPagedList,
  OffComplexTrailersFilters,
  OffComplexWithAppointmentDTO,
  OffComplexWithoutAppointmentRequest,
  OnComplexSettingsModel,
  OnComplexWithAppointmentDTO,
  OnComplexWithoutAppointmentDTO,
  OrderDTO,
  OrderDTOPagedList,
  PartnerDTO,
  PartnerDTOPagedList,
  PartnerWithSitesDTO,
  PatchScacsDTO,
  PatchYardManagementInformationDTO,
  PauseMoveRequestCommand,
  ReferenceTypeDTO,
  RFID_DTOPagedList,
  RFIDTrailerDTO,
  RFIDTrailerDtoPagedList,
  RoleDTO,
  SCAC_DTO,
  SearchDashboardResponse,
  SiteDTO,
  SiteDTOPagedList,
  SiteFilterModel,
  SiteSettingsModel,
  SpotTruckInspectionDTO,
  SpotTruckInspectionSettingsModel,
  TrailerGateInDTO,
  TrailerStatus,
  TrailerTypeDTO,
  TrailerTypeMoveRequestDTO,
  UpdateDoorCollectionDTO,
  UpdateLocationDTO,
  UpdatePartnerDTO,
  UpdateRFIDTrailerDTO,
  UpdateSiteDTO,
  UpdateTrailerMoveRequestDTO,
  UpdateTrailerTypeDTO,
  UserInfoDTO,
  UserOrganizationInformationDTO,
  YardManagementInformationDTO,
} from "./api-types";

export enum ApiUrl {
  ADD_YARD_MANAGEMENT_INFORMATION = "/yardmanagementinformation",
  ALL_PARTNERS = "/partners/all",
  APPOINTMENT_STATUSES = "/appointmentstatuses",
  All_SITES = "/partner/{partnerKey}/sites/all",
  CREATE_MOVE_REQUEST = "/moverequest",
  CREATE_MOVE_REQUEST_COMMENT = "/moverequest/comment",
  CREATE_SITE = "/partner/{partnerKey}/sites",
  CREATE_TRAILER_MOVE_REQUEST = "/moverequest/trailermoverequest",
  CLEAR_NEW_USER = "/users/{id}/reset",
  CURRENT_USER_INFO = "/users/userinfo",
  CUSTOM_REGISTRATION_FORM = "/userorganizationinformations",
  DASHBOARD_TRAILERS_BY_FILTERS = "/dashboard/filtertrailers",
  DEFAULT_LOCATION = "/locations/getdefaultlocation",
  DEFAULT_SCAC = "/scacs/getdefaultscac/{siteId}",
  DIRECTION_TYPES = "/directiontypes",
  DOORS_LOCATIONS = "/locations/doors",
  DOOR_COLLECTION = "/doorcollection/{id}",
  DOOR_COLLECTION_HISTORY = "/doorcollection/history/{id}",
  DOOR_COLLECTIONS = "/doorcollection",
  DOOR_COLLECTION_LIST = "/doorcollection/all",
  DROP_TRAILERS = "/trailers/getdroptrailers",
  ENTERPRISE_PARTNERS = "/partners/enterprise-partners",
  ENTERPRISE_SITES = "/partner/{partnerKey}/sites/enterprise-sites",
  EXPORT_MOVE_REQUESTS_BY_STATUS = "/moverequest/exportmoverequestsexcelwithstatus",
  FILTER_DOORS_BY_DOOR_COLLECTION = "/docks/filterdoorsbydoorcollection",
  FILTER_TRAILERS_BY_NUMBER = "/trailers/filter",
  FILTER_TRAILERS_BY_NUMBER_AND_SCAC = "/trailers/filterbynumberandscac",
  FUEL_LEVELS = "/fuellevels",
  GENERAL_SITE_SETTINGS = "/sites",
  LIVE_PULL_AS_EMPTY_TRAILER = "/moverequest/pullasemptytrailer/{yardManagementInformationId}",
  LIVE_PULL_MOVE_REQUEST = "/moverequest/livepullmoverequest/{yardManagementInformationId}",
  LIVE_SPOT_AS_EMPTY_TRAILER = "/moverequest/spotasemptytrailer/{yardManagementInformationId}",
  LIVE_SPOT_MOVE_REQUEST = "/moverequest/livespotmoverequest",
  LOCATION = "/locations/{id}",
  LOCATIONS = "/locations",
  LOCATIONS_LIST = "/locations/list",
  LOCATION_BY_MR_DOOR_NAME = "/locations/getbymrdoorname",
  LOCATION_BY_NAME = "/locations/getbyname",
  LOCATION_TYPES = "/locationtypes",
  MANAGE_ON_COMPLEX_SETTINGS = "/sitesettings/addorupdateoncomplexsettings",
  MANAGE_SPOT_TRUCK_INSPECTION_SETTINGS = "/sitesettings/addorupdatespottruckinspectionsettings",
  MARK_GATE_IN = "/trailers/gatein",
  MARK_GATE_OUT = "/trailers/{appointmentId}/gateout",
  MARK_OFF_COMPLEX_WITHOUT_APPOINTMENT = "/trailers/offcomplexwithoutappointment",
  MARK_OFF_COMPLEX_WITH_APPOINTMENT = "/trailers/offcomplexwithappointment",
  MARK_ON_COMPLEX_WITHOUT_APPOINTMENT = "/trailers/oncomplexwithoutappointment",
  MARK_ON_COMPLEX_WITH_APPOINTMENT = "/trailers/oncomplexwithappointment",
  MOVE_REASONS = "/movereasons",
  MOVE_REQUEST = "/moverequest/{id}",
  MOVE_REQUESTS = "/moverequest/getmoverequests/{yardManagementInfoId}",
  MOVE_REQUESTS_BY_STATUS = "/moverequest/getmoverequestsbystatus",
  MOVE_REQUEST_COMPLETE_ACTION = "/moverequestactions/complete",
  MOVE_REQUEST_PAUSE_ACTION = "/moverequestactions/Pause",
  MOVE_REQUEST_START_OR_RESUME_OR_TO_PENDING_ACTION = "/moverequestactions/changestatus",
  MOVE_STATUSES = "/movestatuses",
  MOVE_TYPES = "/movetypes",
  MR_DOCKS = "/docks/mrdocks",
  MR_DOORS_LOCATIONS = "/locations/mrdoors",
  MR_SITE_SETTINGS = "/yardmanagementinformation/mrsitesettings",
  NEW_SIGN_UPS = "/users/newsignupusers",
  NEW_SIGN_UPS_COUNT = "/users/newsignupuserscount",
  OFF_COMPLEX_TRAILERS_BY_FILTERS = "/trailers/filteroffcomplextrailers",
  ORDERS = "/orders",
  ORDER_DETAILS = "/yardmanagementinformation/getorderinformation/{appointmentId}",
  PARTNER = "/partners/{id}",
  PARTNERS_WITH_SITES = "/partnersandsites",
  PARTNER_STATUSES = "/partnerstatuses",
  POWER_BI_EMBED_REPORTS = "/pbi/embedparams",
  RFID = "/rfidtrailer/{id}",
  RFIDS = "/rfidtrailer/selectedlist",
  RFID_LIST = "/rfidtrailer/all",
  SCAC = "/scacs/{id}",
  SCACS = "/scacs",
  SCAC_LIST = "/scacs/all",
  SEARCH_TRAILERS_BY_RFID = "/dashboard/searchdashboard/{RFID}",
  SET_DOOR_OUT_OF_SERVICE = "/docks/setdooroutofservice/{doorId}",
  SET_DOOR_TO_WORK = "/docks/setdoortowork/{doorId}",
  SITE_STATUSES = "/sitestatuses",
  SPOT_TRUCK_INSPECTION = "/spottruckinspection",
  SPOT_TRUCK_INSPECTION_FORM_REQUIRED = "/spottruckinspection/isspottruckinspectionrequired",
  TRAILER_HISTORY = "/yardmanagementinformation/history/{id}",
  TRAILER_INFO_BY_RFID_ID = "/rfidtrailer/{RFIDTrailerId}",
  TRAILER_LOAD_STATUSES = "/trailerloadstatuses",
  TRAILER_TYPE = "/trailertypes/{id}",
  TRAILER_TYPES = "/trailertypes",
  TRAILER_TYPES_LIST = "/trailertypes/all",
  TRAILER_TYPE_MOVE_REQUEST = "/moverequest/trailertypemoverequest",
  TRAILER_TYPE_VALUES = "/trailertypes/values",
  TRAILER_STATUSES = "/trailers/trailerstatuses",
  UPDATE_PARTNER = "/partners",
  UPDATE_RFID = "/rfidtrailer",
  UPDATE_SITE_PREFERENCES = "/sitesettings/addorupdatedisplayfields",
  UPDATE_TRAILER_MOVE_REQUEST = "/moverequest/trailermoverequest/{id}",
  USER_ROLES = "/roles",
  YARD_MANAGEMENT_INFORMATION = "/yardmanagementinformation/{id}",
  YMS_DOORS_WITH_MR_DOOR_IDS = "/locations/ymscorrespondingmrdoors",
  YMS_SITE_SETTINGS = "/sitesettings",
}

export interface UrlOperations {
  [ApiUrl.APPOINTMENT_STATUSES]: {
    get: { response: AppointmentStatusesResponse };
  };
  [ApiUrl.CREATE_MOVE_REQUEST]: {
    post: {
      requestBody: AddMoveRequestDTO;
      response: MoveRequestDTO;
    };
  };
  [ApiUrl.CREATE_MOVE_REQUEST_COMMENT]: {
    post: {
      requestBody: AddMoveRequestCommentDTO;
      response: MoveRequestCommentDTO;
    };
  };
  [ApiUrl.CREATE_TRAILER_MOVE_REQUEST]: {
    post: {
      requestBody: AddTrailerMoveRequestDTO;
      response: MoveRequestDTO;
    };
  };
  [ApiUrl.CUSTOM_REGISTRATION_FORM]: {
    post: {
      requestBody: AddUserOrganizationInformationDTO;
      response: UserOrganizationInformationDTO;
    };
  };
  [ApiUrl.CURRENT_USER_INFO]: {
    get: {
      response: UserInfoDTO;
    };
  };
  [ApiUrl.EXPORT_MOVE_REQUESTS_BY_STATUS]: {
    get: {
      parameters: {
        path: never;
        query: { moveStatusId: number; timeZone: string };
      };
      response: Blob;
    };
    post: never;
    put: never;
    patch: never;
    delete: never;
  };
  [ApiUrl.MANAGE_SPOT_TRUCK_INSPECTION_SETTINGS]: {
    get: never;
    post: {
      parameters: never;
      requestBody: SpotTruckInspectionSettingsModel;
      response: SpotTruckInspectionSettingsModel;
    };
    put: never;
    patch: never;
    delete: never;
  };
  [ApiUrl.MANAGE_ON_COMPLEX_SETTINGS]: {
    get: never;
    post: {
      parameters: never;
      requestBody: OnComplexSettingsModel;
      response: OnComplexSettingsModel;
    };
    put: never;
    patch: never;
    delete: never;
  };
  [ApiUrl.DASHBOARD_TRAILERS_BY_FILTERS]: {
    post: {
      requestBody: FilterDashboardTrailersDTO;
      response: DashboardParentDTO;
    };
  };
  [ApiUrl.DEFAULT_LOCATION]: {
    get: {
      response: LocationDTO;
    };
  };
  [ApiUrl.DEFAULT_SCAC]: {
    get: {
      parameters: { path: { siteId: number } };
      response: SCAC_DTO;
    };
  };
  [ApiUrl.DIRECTION_TYPES]: {
    get: { parameters: never; response: ReferenceTypeDTO[] };
    post: never;
    put: never;
    patch: never;
    delete: never;
  };
  [ApiUrl.FILTER_TRAILERS_BY_NUMBER]: {
    get: never;
    post: {
      parameters: never;
      requestBody: {
        trailerNumber: string;
        isTrailerLoadStatusEmpty?: boolean;
      };
      response: FilterTrailersResponseDTO[];
    };
    put: never;
    patch: never;
    delete: never;
  };
  [ApiUrl.FILTER_TRAILERS_BY_NUMBER_AND_SCAC]: {
    get: {
      parameters: {
        path: never;
        query: { trailerNumber: string; scacId: number };
      };
      response: FilterByTrailerNumberAndScacDTO | null;
    };
    post: never;
    put: never;
    patch: never;
    delete: never;
  };
  [ApiUrl.FUEL_LEVELS]: {
    get: {
      parameters: never;
      response: ReferenceTypeDTO[];
    };
    post: never;
    put: never;
    patch: never;
    delete: never;
  };
  [ApiUrl.GENERAL_SITE_SETTINGS]: {
    put: {
      requestBody: UpdateSiteDTO;
      response: GetSiteDTO;
    };
  };
  [ApiUrl.LIVE_PULL_AS_EMPTY_TRAILER]: {
    get: never;
    post: {
      parameters: {
        path: { yardManagementInformationId: number };
        query: never;
      };
      requestBody: never;
      response: YardManagementInformationDTO;
    };
    put: never;
    patch: never;
    delete: never;
  };
  [ApiUrl.LIVE_PULL_MOVE_REQUEST]: {
    get: never;
    post: {
      parameters: {
        path: { yardManagementInformationId: number };
        query: never;
      };
      requestBody: never;
      response: { message: string };
    };
    put: never;
    patch: never;
    delete: never;
  };
  [ApiUrl.LIVE_SPOT_AS_EMPTY_TRAILER]: {
    get: never;
    post: {
      parameters: {
        path: { yardManagementInformationId: number };
        query: never;
      };
      requestBody: never;
      response: YardManagementInformationDTO;
    };
    put: never;
    patch: never;
    delete: never;
  };
  [ApiUrl.LIVE_SPOT_MOVE_REQUEST]: {
    get: never;
    post: {
      parameters: never;
      requestBody: LiveSpotMoveRequestDTO;
      response: { message: string };
    };
    put: never;
    patch: never;
    delete: never;
  };
  [ApiUrl.LOCATION_BY_NAME]: {
    get: {
      parameters: { path: never; query: { name: string } };
      response: DoorDTO;
    };
    post: never;
    put: never;
    patch: never;
    delete: never;
  };
  [ApiUrl.LOCATION_TYPES]: {
    get: {
      parameters: never;
      response: LocationTypeDTO[];
    };
    post: never;
    put: never;
    patch: never;
    delete: never;
  };
  [ApiUrl.LOCATION_BY_MR_DOOR_NAME]: {
    get: {
      parameters: { path: never; query: { mrDoorName: string } };
      response: DoorDTO;
    };
    post: never;
    put: never;
    patch: never;
    delete: never;
  };
  [ApiUrl.MOVE_STATUSES]: {
    get: {
      parameters: never;
      response: ReferenceTypeDTO[];
    };
    post: never;
    put: never;
    patch: never;
    delete: never;
  };
  [ApiUrl.MOVE_REASONS]: {
    get: {
      parameters: never;
      response: ReferenceTypeDTO[];
    };
    post: never;
    put: never;
    patch: never;
    delete: never;
  };
  [ApiUrl.MOVE_TYPES]: {
    get: {
      parameters: {
        path: never;
        query: { onlyMoveTypesCreatedFromYMS: boolean };
      };
      response: ReferenceTypeDTO[];
    };
    post: never;
    put: never;
    patch: never;
    delete: never;
  };
  [ApiUrl.OFF_COMPLEX_TRAILERS_BY_FILTERS]: {
    get: never;
    post: {
      parameters: never;
      requestBody: OffComplexTrailersFilters;
      response: OffComplexTrailerPagedList;
    };
    put: never;
    patch: never;
    delete: never;
  };
  [ApiUrl.LOCATION]: {
    get: {
      parameters: {
        path: { id: number };
        query: never;
      };
      requestBody: never;
      response: LocationDetailsDTO;
    };
    post: never;
    put: never;
    patch: never;
    delete: {
      parameters: {
        path: { id: number };
        query: never;
      };
      response: boolean;
    };
  };
  [ApiUrl.LOCATIONS]: {
    get: {
      parameters: { path: never; query: { searchKey?: string } };
      response: LocationDTO[];
    };
    post: {
      parameters: never;
      requestBody: AddLocationDTO;
      response: LocationListDTO;
    };
    put: {
      parameters: never;
      requestBody: UpdateLocationDTO;
      response: LocationListDTO;
    };
    patch: never;
    delete: never;
  };
  [ApiUrl.LOCATIONS_LIST]: {
    get: never;
    post: {
      parameters: never;
      requestBody: GetLocationsListFilterModel;
      response: LocationListDTOPagedList;
    };
    put: never;
    patch: never;
    delete: never;
  };
  [ApiUrl.DOORS_LOCATIONS]: {
    get: {
      parameters: { path: never; query: { searchKey?: string } };
      response: DoorDTO[];
    };
    post: never;
    put: never;
    patch: never;
    delete: never;
  };
  [ApiUrl.DOOR_COLLECTION_LIST]: {
    get: never;
    post: {
      parameters: never;
      requestBody: GetDoorCollectionFilterModel;
      response: GetDoorCollectionDTOPagedList;
    };
    put: never;
    patch: never;
    delete: never;
  };
  [ApiUrl.DOOR_COLLECTIONS]: {
    get: {
      response: DoorCollectionDTO[];
    };
    post: {
      requestBody: AddDoorCollectionDTO;
      response: DoorCollectionDTO;
    };
    put: {
      requestBody: UpdateDoorCollectionDTO;
      response: DoorCollectionWithDoorsDTO;
    };
  };
  [ApiUrl.DOOR_COLLECTION]: {
    get: {
      parameters: {
        path: { id: number };
      };
      response: DoorCollectionWithDoorsDTO;
    };
    delete: {
      parameters: {
        path: { id: number };
      };
      response: boolean;
    };
  };
  [ApiUrl.DOOR_COLLECTION_HISTORY]: {
    get: {
      parameters: {
        path: { id: number };
      };
      response: HistoryBase[];
    };
  };
  [ApiUrl.DROP_TRAILERS]: {
    get: never;
    post: {
      parameters: never;
      requestBody: DropTrailersFiltersDTO;
      response: DropTrailersDTOPagedList;
    };
    put: never;
    patch: never;
    delete: never;
  };
  [ApiUrl.ENTERPRISE_PARTNERS]: {
    get: {
      parameters: { query: { searchKey: string } };
      response: EnterprisePartnerDTO[];
    };
  };
  [ApiUrl.ENTERPRISE_SITES]: {
    get: {
      parameters: { path: { partnerKey: string } };
      response: EnterpriseSiteDTO[];
    };
  };
  [ApiUrl.FILTER_DOORS_BY_DOOR_COLLECTION]: {
    get: never;
    post: {
      parameters: never;
      requestBody: FilterDoorsByDoorCollectionDTO;
      response: DashboardDoorDTO[];
    };
    put: never;
    patch: never;
    delete: never;
  };
  [ApiUrl.MARK_ON_COMPLEX_WITH_APPOINTMENT]: {
    get: never;
    post: {
      parameters: never;
      requestBody: OnComplexWithAppointmentDTO;
      response: void;
    };
    put: never;
    patch: never;
    delete: never;
  };
  [ApiUrl.MARK_GATE_IN]: {
    get: never;
    post: {
      parameters: {
        path: never;
        query: never;
      };
      requestBody: TrailerGateInDTO;
      response: never;
    };
    put: never;
    patch: never;
    delete: never;
  };
  [ApiUrl.MARK_GATE_OUT]: {
    get: never;
    post: {
      parameters: {
        path: { appointmentId: number };
        query: never;
      };
      requestBody: null;
      response: void;
    };
    put: never;
    patch: never;
    delete: never;
  };
  [ApiUrl.MARK_ON_COMPLEX_WITHOUT_APPOINTMENT]: {
    get: never;
    post: {
      parameters: never;
      requestBody: OnComplexWithoutAppointmentDTO;
      response: void;
    };
    put: never;
    patch: never;
    delete: never;
  };
  [ApiUrl.MR_DOCKS]: {
    get: {
      parameters: never;
      response: AppointmentDockDTO[];
    };
    post: never;
    put: never;
    patch: never;
    delete: never;
  };
  [ApiUrl.MR_DOORS_LOCATIONS]: {
    get: {
      parameters: {
        path: never;
        query?: {
          hasFiltered?: boolean;
        };
      };
      response: MRDoorDTO[];
    };
    post: never;
    put: never;
    patch: never;
    delete: never;
  };
  [ApiUrl.YMS_DOORS_WITH_MR_DOOR_IDS]: {
    get: {
      parameters: never;
      response: DoorDTO[];
    };
    post: never;
    put: never;
    patch: never;
    delete: never;
  };
  [ApiUrl.ORDERS]: {
    get: {
      parameters: {
        path: never;
        query: { search?: string; pageNumber: number; pageSize: number };
      };
      response: OrderDTOPagedList;
    };
    post: {
      parameters: never;
      requestBody: {
        searchKey: string;
      };
      response: OrderDTO;
    };
    put: never;
    patch: never;
    delete: {
      parameters: {
        path: never;
        query: never;
      };
      response: never;
    };
  };
  [ApiUrl.ORDER_DETAILS]: {
    get: {
      parameters: { path: { appointmentId: number }; query: never };
      response: AppointmentWithYardManagementDTO;
    };
    post: never;
    put: never;
    patch: never;
    delete: never;
  };
  [ApiUrl.POWER_BI_EMBED_REPORTS]: {
    get: never;
    post: {
      parameters: never;
      requestBody: never;
      response: never;
    };
    put: never;
    patch: never;
    delete: never;
  };

  [ApiUrl.PARTNERS_WITH_SITES]: {
    get: {
      parameters: {
        path: never;
        query: never;
      };
      response: PartnerWithSitesDTO[];
    };
    post: {
      parameters: { path: never };
      requestBody: never;
      response: never;
    };
    put: never;
    patch: never;
    delete: {
      parameters: {
        path: never;
        query: never;
      };
      response: never;
    };
  };
  [ApiUrl.PARTNER_STATUSES]: {
    get: { response: ReferenceTypeDTO[] };
  };
  [ApiUrl.PARTNER]: {
    get: {
      parameters: {
        path: { id: number };
        query: never;
      };
      requestBody: never;
      response: PartnerDTO;
    };
    post: never;
    put: never;
    patch: never;
    delete: never;
  };
  [ApiUrl.RFID_LIST]: {
    get: never;
    post: {
      parameters: never;
      requestBody: GetRFIDTrailersFilterModel;
      response: RFIDTrailerDtoPagedList;
    };
    put: never;
    patch: never;
    delete: never;
  };
  [ApiUrl.RFID]: {
    get: {
      parameters: {
        path: { id: number };
        query: never;
      };
      response: RFIDTrailerDTO;
    };
    post: never;
    put: never;
    patch: never;
    delete: {
      parameters: {
        path: { id: number };
        query: never;
      };
      response: boolean;
    };
  };
  [ApiUrl.RFIDS]: {
    post: {
      parameters: never;
      requestBody: GetRFIDTrailerSelectedListFilterModel;
      response: RFID_DTOPagedList;
    };
  };
  [ApiUrl.UPDATE_RFID]: {
    get: never;
    post: {
      parameters: never;
      requestBody: AddRFIDTrailerDTO;
      response: RFIDTrailerDTO;
    };
    put: {
      parameters: never;
      requestBody: UpdateRFIDTrailerDTO;
      response: RFIDTrailerDTO;
    };
    patch: never;
    delete: never;
  };
  [ApiUrl.SEARCH_TRAILERS_BY_RFID]: {
    get: {
      parameters: {
        path: {
          RFID: string;
        };
        query: never;
      };
      response: SearchDashboardResponse;
    };
    post: never;
    put: never;
    patch: never;
    delete: never;
  };
  [ApiUrl.SET_DOOR_OUT_OF_SERVICE]: {
    get: never;
    post: {
      parameters: {
        path: { doorId: number };
        query: never;
      };
      requestBody: never;
      response: void;
    };
    put: never;
    patch: never;
    delete: never;
  };
  [ApiUrl.SET_DOOR_TO_WORK]: {
    get: never;
    post: {
      parameters: {
        path: { doorId: number };
        query: never;
      };
      requestBody: never;
      response: void;
    };
    put: never;
    patch: never;
    delete: never;
  };
  [ApiUrl.SITE_STATUSES]: {
    get: { response: ReferenceTypeDTO[] };
  };
  [ApiUrl.SCACS]: {
    post: {
      requestBody: GetSCACsSelectedListFilterModel;
      response: GetSelectedSCACDTOPagedList;
    };
  };
  [ApiUrl.SCAC]: {
    delete: {
      parameters: { path: { id: number } };
      response: boolean;
    };
    patch: {
      parameters: { path: { id: number } };
      requestBody: PatchScacsDTO;
      response: SCAC_DTO;
    };
  };
  [ApiUrl.SCAC_LIST]: {
    post: {
      requestBody: GetSCACsFilterModel;
      response: GetSCACDTOPagedList;
    };
  };
  [ApiUrl.SPOT_TRUCK_INSPECTION]: {
    get: never;
    post: {
      parameters: never;
      requestBody: SpotTruckInspectionDTO;
      response: void;
    };
    put: never;
    patch: never;
    delete: never;
  };

  [ApiUrl.SPOT_TRUCK_INSPECTION_FORM_REQUIRED]: {
    get: {
      parameters: never;
      response: boolean;
    };
    post: never;
    put: never;
    patch: never;
    delete: never;
  };
  [ApiUrl.MR_SITE_SETTINGS]: {
    get: {
      parameters: never;
      response: MrSiteSettingsForYardManagementInformationDTO;
    };
    post: never;
    put: never;
    patch: never;
    delete: never;
  };
  [ApiUrl.CLEAR_NEW_USER]: {
    patch: {
      parameters: {
        path: { id: number };
      };
      response: boolean;
    };
  };
  [ApiUrl.NEW_SIGN_UPS]: {
    post: {
      parameters: never;
      requestBody: GetNewSignUpUsersFilterModel;
      response: NewSignUpUserModelPagedList;
    };
  };
  [ApiUrl.NEW_SIGN_UPS_COUNT]: {
    get: { response: number };
  };
  [ApiUrl.YMS_SITE_SETTINGS]: {
    get: {
      parameters: never;
      response: SiteSettingsModel;
    };
    post: never;
    put: never;
    patch: never;
    delete: never;
  };
  [ApiUrl.TRAILER_HISTORY]: {
    get: {
      parameters: {
        path: {
          id: number;
        };
        query: never;
      };
      response: History[];
    };
    post: never;
    put: never;
    patch: never;
    delete: never;
  };
  [ApiUrl.TRAILER_INFO_BY_RFID_ID]: {
    get: {
      parameters: {
        path: {
          RFIDTrailerId: number;
        };
        query: never;
      };
      response: RFIDTrailerDTO;
    };
    post: never;
    put: never;
    patch: never;
    delete: never;
  };
  [ApiUrl.TRAILER_LOAD_STATUSES]: {
    get: {
      parameters: never;
      response: ReferenceTypeDTO[];
    };
    post: never;
    put: never;
    patch: never;
    delete: never;
  };
  [ApiUrl.TRAILER_TYPE]: {
    get: {
      parameters: {
        path: { id: number };
      };
      response: TrailerTypeDTO;
    };
  };
  [ApiUrl.TRAILER_TYPES]: {
    get: { response: TrailerTypeDTO[] };
    post: {
      requestBody: AddTrailerTypeDTO;
      response: TrailerTypeDTO;
    };
    put: {
      requestBody: UpdateTrailerTypeDTO;
      response: TrailerTypeDTO;
    };
  };
  [ApiUrl.TRAILER_TYPES_LIST]: {
    post: {
      requestBody: GetTrailerTypesFilterModel;
      response: GetTrailerTypeDTOPagedList;
    };
  };
  [ApiUrl.TRAILER_TYPE_VALUES]: {
    get: {
      response: string[];
    };
  };
  [ApiUrl.USER_ROLES]: {
    get: {
      parameters: {
        path: never;
        query: { siteId: number; partnerKey: string };
      };
      response: RoleDTO[];
    };
    post: never;
    put: never;
    patch: never;
    delete: never;
  };
  [ApiUrl.ADD_YARD_MANAGEMENT_INFORMATION]: {
    get: never;
    post: {
      parameters: never;
      requestBody: AddYardManagementInformationDTO;
      response: YardManagementInformationDTO;
    };
    put: never;
    patch: never;
    delete: never;
  };
  [ApiUrl.ALL_PARTNERS]: {
    get: never;
    post: {
      parameters: never;
      requestBody: GetPartnersFilterModel;
      response: PartnerDTOPagedList;
    };
    put: never;
    patch: never;
    delete: never;
  };
  [ApiUrl.All_SITES]: {
    get: never;
    post: {
      parameters: { path: { partnerKey: string }; query: never };
      requestBody: SiteFilterModel;
      response: SiteDTOPagedList;
    };
    put: never;
    patch: never;
    delete: never;
  };
  [ApiUrl.YARD_MANAGEMENT_INFORMATION]: {
    get: {
      parameters: { path: { id: number }; query: never };
      response: YardManagementInformationDTO;
    };
    post: never;
    put: never;
    patch: {
      parameters: {
        path: { id: number };
        query: never;
      };
      requestBody: Partial<PatchYardManagementInformationDTO>;
      response: void;
    };
    delete: never;
  };
  [ApiUrl.UPDATE_PARTNER]: {
    get: never;
    post: {
      requestBody: AddPartnerDTO;
      response: PartnerDTO;
    };
    put: {
      parameters: never;
      requestBody: UpdatePartnerDTO;
      response: PartnerDTO;
    };
    patch: never;
    delete: never;
  };
  [ApiUrl.CREATE_SITE]: {
    post: {
      parameters: { path: { partnerKey: string } };
      requestBody: AddSiteDTO;
      response: SiteDTO;
    };
  };
  [ApiUrl.UPDATE_SITE_PREFERENCES]: {
    get: never;
    post: {
      parameters: never;
      requestBody: DisplayFieldsModel;
      response: DisplayFieldsModel;
    };
    put: never;
    patch: never;
    delete: never;
  };
  [ApiUrl.UPDATE_TRAILER_MOVE_REQUEST]: {
    get: never;
    post: never;
    put: {
      parameters: { path: { id: number }; query: never };
      requestBody: UpdateTrailerMoveRequestDTO;
      response: MoveRequestDTO;
    };
    patch: never;
    delete: never;
  };
  [ApiUrl.MARK_OFF_COMPLEX_WITHOUT_APPOINTMENT]: {
    get: never;
    post: {
      parameters: never;
      requestBody: OffComplexWithoutAppointmentRequest;
      response: void;
    };
    put: never;
    patch: never;
    delete: never;
  };
  [ApiUrl.TRAILER_STATUSES]: {
    get: { parameters: never; response: TrailerStatus[] };
    post: never;
    put: never;
    patch: never;
    delete: never;
  };
  [ApiUrl.TRAILER_TYPE_MOVE_REQUEST]: {
    get: never;
    post: {
      parameters: never;
      requestBody: TrailerTypeMoveRequestDTO;
      response: MoveRequestDTO;
    };
    put: never;
    patch: never;
    delete: never;
  };
  [ApiUrl.MARK_OFF_COMPLEX_WITH_APPOINTMENT]: {
    get: never;
    post: {
      parameters: never;
      requestBody: OffComplexWithAppointmentDTO;
      response: void;
    };
    put: never;
    patch: never;
    delete: never;
  };
  [ApiUrl.MOVE_REQUESTS]: {
    get: {
      parameters: {
        path: { yardManagementInfoId: number };
        query: never;
      };
      response: MoveRequestDTO[];
    };
    post: never;
    put: never;
    patch: never;
    delete: never;
  };
  [ApiUrl.MOVE_REQUEST_START_OR_RESUME_OR_TO_PENDING_ACTION]: {
    get: never;
    post: {
      parameters: never;
      requestBody: ChangeMoveRequestStatusCommand;
      response: MoveRequestDTO;
    };
    put: never;
    patch: never;
    delete: never;
  };
  [ApiUrl.MOVE_REQUEST_PAUSE_ACTION]: {
    get: never;
    post: {
      parameters: never;
      requestBody: PauseMoveRequestCommand;
      response: MoveRequestDTO;
    };
    put: never;
    patch: never;
    delete: never;
  };
  [ApiUrl.MOVE_REQUEST_COMPLETE_ACTION]: {
    get: never;
    post: {
      parameters: never;
      requestBody: CompleteMoveRequestCommand;
      response: MoveRequestDTO;
    };
    put: never;
    patch: never;
    delete: never;
  };
  [ApiUrl.MOVE_REQUESTS_BY_STATUS]: {
    get: never;
    post: {
      parameters: never;
      requestBody: MoveRequestFilterModel;
      response: MoveRequestForListDTOPagedList;
    };
    put: never;
    patch: never;
    delete: never;
  };
  [ApiUrl.MOVE_REQUEST]: {
    get: {
      parameters: {
        path: { id: number };
        query: never;
      };
      response: MoveRequestDTO;
    };
    post: never;
    put: never;
    patch: never;
    delete: {
      parameters: {
        path: { id: number };
        query: never;
      };
      response: void;
    };
  };
}

export const generateApiURL = <
  PathParams extends object | undefined,
  QueryParams extends object | undefined,
>({
  prefix = "",
  path,
  pathParams,
  queryParams,
}: {
  prefix?: string;
  path: ApiUrl;
  pathParams?: PathParams;
  queryParams?: QueryParams;
}): string => {
  // Generate dynamic url by replacing its placeholder params
  const replaceURLParams = (
    pathTemplate: ApiUrl,
    pathParams: PathParams | undefined,
  ): string => {
    if (!isExistent(pathParams)) {
      return pathTemplate;
    }
    // The selector (.+?) matches anything between curly braces except newline
    return pathTemplate.replace(
      /{(.+?)}/g,
      (_, key: keyof PathParams): string => String(pathParams[key] || key),
    );
  };

  const generatedUrl = `${removeTrailingSlash(
    environment.apiUrls.yms.href,
  )}${prefix}${replaceURLParams(path, pathParams)}`;

  // Generate query params string
  const cleanedQueryParams = pickBy(queryParams, (value) => !isBlank(value));
  const buildURLQuery = (queryParams: object): string =>
    Object.entries(queryParams)
      .map((pair) => pair.map(encodeURIComponent).join("="))
      .join("&");
  const generatedQueryParams = buildURLQuery(cleanedQueryParams);

  return generatedQueryParams
    ? `${generatedUrl}?${generatedQueryParams}`
    : generatedUrl;
};

const isBlank = (value: string | number | undefined): boolean => {
  if (typeof value === "string") {
    return value?.length === 0 || !value?.trim();
  }
  return value === undefined;
};

function removeTrailingSlash(url: string): string {
  return url.replace(/\/$/, "");
}

// #region  Types utils

export enum HttpMethod {
  GET = "get",
  POST = "post",
  PUT = "put",
  PATCH = "patch",
  DELETE = "delete",
}

type Operation<
  Url extends ApiUrl,
  Method extends HttpMethod,
> = UrlOperations[Url] extends {
  [K in Method]: infer O;
}
  ? O
  : never;

// #region Generic type extractors
type ExtractQueryParams<T> = T extends { parameters: { query?: infer Q } }
  ? Q extends object
    ? Q
    : never
  : never;

type ExtractPathParams<T> = T extends { parameters: { path: infer P } }
  ? P extends object
    ? P
    : never
  : never;

type ExtractRequestBody<T> = T extends { requestBody: infer B } ? B : never;
type ExtractResponse<T> = T extends { response: infer R } ? R : never;
// #endregion

// #region Generic type utilities
type QueryParamsOperation<
  Url extends ApiUrl,
  Method extends HttpMethod,
> = ExtractQueryParams<Operation<Url, Method>>;

type PathParamsOperation<
  Url extends ApiUrl,
  Method extends HttpMethod,
> = ExtractPathParams<Operation<Url, Method>>;

type ResponseOperation<
  Url extends ApiUrl,
  Method extends HttpMethod,
> = ExtractResponse<Operation<Url, Method>>;

type RequestBodyOperation<
  Url extends ApiUrl,
  Method extends HttpMethod,
> = ExtractRequestBody<Operation<Url, Method>>;
// #endregion

// #region Get Operations
export type GetOperationQueryParams<Url extends ApiUrl> = QueryParamsOperation<
  Url,
  HttpMethod.GET
>;

export type PathParamsOfGetOperation<Url extends ApiUrl> = PathParamsOperation<
  Url,
  HttpMethod.GET
>;

export type ResponseOfGetOperation<Url extends ApiUrl> = ResponseOperation<
  Url,
  HttpMethod.GET
>;
// #endregion

// #region Post Operations
export type PostOperationPathParams<Url extends ApiUrl> = PathParamsOperation<
  Url,
  HttpMethod.POST
>;

export type PostOperationRequestBody<Url extends ApiUrl> = RequestBodyOperation<
  Url,
  HttpMethod.POST
>;

export type PostOperationResponse<Url extends ApiUrl> = ResponseOperation<
  Url,
  HttpMethod.POST
>;
// #endregion

// #region Patch Operations
export type PatchOperationPathParams<Url extends ApiUrl> = PathParamsOperation<
  Url,
  HttpMethod.PATCH
>;

export type PatchOperationRequestBody<Url extends ApiUrl> =
  RequestBodyOperation<Url, HttpMethod.PATCH>;

export type PatchOperationResponse<Url extends ApiUrl> = ResponseOperation<
  Url,
  HttpMethod.PATCH
>;
// #endregion

// #region Put Operations
export type PutOperationPathParams<Url extends ApiUrl> = PathParamsOperation<
  Url,
  HttpMethod.PUT
>;

export type PutOperationRequestBody<Url extends ApiUrl> = RequestBodyOperation<
  Url,
  HttpMethod.PUT
>;

export type PutOperationResponse<Url extends ApiUrl> = ResponseOperation<
  Url,
  HttpMethod.PUT
>;
// #endregion

// #region  Delete Operations
export type DeleteOperationQueryParams<Url extends ApiUrl> =
  QueryParamsOperation<Url, HttpMethod.DELETE>;

export type DeleteOperationPathParams<Url extends ApiUrl> = PathParamsOperation<
  Url,
  HttpMethod.DELETE
>;

export type DeleteOperationRequestBody<Url extends ApiUrl> =
  RequestBodyOperation<Url, HttpMethod.DELETE>;

export type DeleteOperationResponse<Url extends ApiUrl> = ResponseOperation<
  Url,
  HttpMethod.DELETE
>;
// #endregion

// #endregion
